module.exports = {
  environmentName: 'production',
  contextHubInstance: global.ContextHub,
  originDomain: 'https://origin-preprod.adobecqms.net/',
  apiUrls: {
    plans: '',
  },
};
